import { render, staticRenderFns } from "./storageRecord.vue?vue&type=template&id=2bc7e0e6"
import script from "./storageRecord.vue?vue&type=script&lang=js"
export * from "./storageRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports